module.exports = __webpack_public_path__ + "img/hardening.52133b5.svg";